<template>
  <div class="modal-main">
    <SmsCodeModal
      ref="smsCodeModalRef"
      @sendCode="handleSendCode"
      :modalTitle="`核销无误确认`"
      :checkType="`addOrUpdaterAuditNode`"
    >
      <template v-slot:header>
        <p>
          确认账单即表示对本周期的账款确认无误，确认后系统即将安排本周期账款的结算处理，是否确认该账单？
        </p>
      </template>
    </SmsCodeModal>
  </div>
</template>

<script>
import SmsCodeModal from '@c/Base/SmsCodeModal.vue';
export default {
  components: {
    SmsCodeModal
  },
  mounted() {
    // this.$refs.smsCodeModalRef.handleOpen()
  },
  methods: {
    handleSendCode(phoneCode) {

    }
  }
}
</script>

<style lang="scss" scoped>
.modal-main {
}
</style>